// extracted by mini-css-extract-plugin
export var block = "Mix-module--block--7FlyO";
export var blockCta = "Mix-module--blockCta--D-4cp";
export var blockHeadline = "Mix-module--blockHeadline--8NxUm";
export var blockText = "Mix-module--blockText--z3kJ2";
export var byLine = "Mix-module--byLine--IVCJq";
export var headline = "Mix-module--headline--PMo3c";
export var highlightBlock = "Mix-module--highlightBlock--ZiCgm";
export var highlightBlockImage = "Mix-module--highlightBlockImage--B459+";
export var highlightBlockWithImage = "Mix-module--highlightBlockWithImage--smTT3";
export var image = "Mix-module--image--574Ej";
export var introImage = "Mix-module--introImage--WGdHr";
export var introSection = "Mix-module--introSection--g50tB";
export var introSectionRight = "Mix-module--introSectionRight--W7xBu";
export var introText = "Mix-module--introText--ilH3E";
export var label = "Mix-module--label--1GueO";
export var lowerSection = "Mix-module--lowerSection---YFj5";
export var name = "Mix-module--name--k+I33";
export var root = "Mix-module--root--bepH3";
export var share = "Mix-module--share--vJF4z";
export var shareRight = "Mix-module--shareRight--663It";
export var text = "Mix-module--text--bIHc0";
export var titleLeft = "Mix-module--titleLeft--uYb9G";